/* Las tres placas del logo de siempre, en el cuadro de 54 × 64 del SVG. */
export const POLIGONOS: ReadonlyArray<ReadonlyArray<readonly [number, number]>> = [
  [
    [8, 4],
    [36, 4],
    [28, 60],
    [0, 60],
  ],
  [
    [18, 8],
    [44, 8],
    [38, 56],
    [12, 56],
  ],
  [
    [28, 12],
    [52, 12],
    [48, 52],
    [24, 52],
  ],
];

export const MEDIDAS_DE_PLACA = POLIGONOS.map((p) => ({
  cx: p.reduce((s, q) => s + q[0], 0) / 4,
  cy: p.reduce((s, q) => s + q[1], 0) / 4,
  ancho: p[1][0] - p[0][0],
  alto: p[2][1] - p[0][1],
}));
